module.exports = __webpack_public_path__ + "static/media/2_armies.c56481fe.png";